<ng-container *ngIf="isCurrentVaccination">
  <ion-item *ngIf="!doseReceived(doseNo)" class="pending">
    <mat-radio-button
      [disabled]="!isEligible()"
      [value]="doseInfo"
      class="example-margin"
      color="primary"
    >
      {{ doseName }}
    </mat-radio-button>
    <ion-note *ngIf="isEligible()" slot="end">{{
      "Eligible" | translate
    }}</ion-note>
    <ion-note *ngIf="!isEligible()" slot="end">{{
      "Not Given" | translate
    }}</ion-note>
  </ion-item>
  <ion-item *ngIf="doseReceived(doseNo)" class="due">
    <ion-label>{{ doseName }}</ion-label>
    <ion-note slot="end">{{
      getVaccinationDate() | displayDateFormat
    }}</ion-note>
  </ion-item>
</ng-container>
<ng-container *ngIf="!isCurrentVaccination">
  <ion-row class="dose-labels">
    <ion-col size="5">
      <mat-checkbox class="example-margin" color="primary">{{
        doseName
      }}</mat-checkbox>
    </ion-col>
    <ion-col size="7">
      <mat-form-field appearance="outline" class="matDropdown">
        <input
          matInput
          readonly
          [max]="getMaxDoseDate()"
          [min]="getMinDoseDate()"
        />
        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
        <mat-datepicker #dp></mat-datepicker>
      </mat-form-field>
    </ion-col>
  </ion-row>
  <!-- <ion-row>
    <ion-col size="12">
      <ion-item class="completed">
        <ion-label> OPV-2 </ion-label>
        <ion-note slot="end">{{ "Updated" | translate }}</ion-note>
      </ion-item>
    </ion-col>
  </ion-row> -->
</ng-container>
